import { Dispatch, SetStateAction, useState } from 'react';
import { Table, Pagination } from 'antd';

interface Props {
  columns: any[];
  data: any[];
  total: number;
  setSelectedItem?: Dispatch<SetStateAction<{}>>;
  setPageNo: Dispatch<SetStateAction<number>>;
  setVisible?: Dispatch<SetStateAction<boolean>>;
  pageNo: number;
  pageSize: number;
  tableLoading?: boolean;
  expandable?: any;
  bordered?: boolean
}

const ItemListPagination = ({ expandable, columns, data, total, setSelectedItem, setPageNo, setVisible, pageNo, pageSize, tableLoading, bordered }: Props) => {
  // const view = (record: any) => {
  //   if (setSelectedItem)
  //     setSelectedItem(record);
  //   if (setVisible)
  //     setVisible(true);
  // }
  const [selectedIndex] = useState(-1);

  const onPageChange = (event: any) => {
    setPageNo(event);
    const mainLayout = document.getElementById('main-layout');
    if (mainLayout) {
      mainLayout.scrollTop = 0;
    }
  }


  return (
    <>
      <Table columns={columns} dataSource={data}
        rowClassName={(record) => record.id === selectedIndex ? "ant-row-style1" : "ant-row-style"}
        pagination={false}
        expandable={expandable}
        loading={tableLoading}
        bordered={bordered}
        onRow={(record) => {
          return {
            // onClick: event => {
            //   setSelectedIndex(record.id);
            //   view(record);
            //   event.preventDefault();
            // }
          };
        }} />
      <Pagination current={pageNo} pageSize={pageSize} onChange={onPageChange} total={total} showSizeChanger={false} />
    </>
  )
};

export default ItemListPagination;